export default __webpack_public_path__ + "static/media/classes-new.9f813d6b.svg";